import { Box, Stack, Typography, IconButton as MuiIconButton } from "@mui/material";
import { DeleteOutlineRounded, InsertDriveFile } from "@mui/icons-material";

export const DocumentItem = ({ doc, canDelete, onDelete }: any) => {
  const name = doc?.uploadedFile?.originalName || doc?.name || "Document";
  const url = doc?.uploadedFile?.url;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
        <InsertDriveFile sx={{ fontSize: 18, color: "primary.main" }} />

        <Box sx={{ minWidth: 0 }}>
          {url ? (
            <Typography
              variant="body2"
              fontWeight={500}
              component="a"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "inherit", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              {name}
            </Typography>
          ) : (
            <Typography variant="body2" fontWeight={500}>
              {name}
            </Typography>
          )}
        </Box>
      </Stack>

      {canDelete && (
        <MuiIconButton size="small" onClick={() => onDelete?.(doc.id)}>
          <DeleteOutlineRounded fontSize="small" color="error" />
        </MuiIconButton>
      )}
    </Box>
  );
};
